<template>
  <HeadlessTransitionRoot appear :show="props.isOpen" as="template">
    <HeadlessDialog @close="$emit('close')" class="relative z-50">
      <HeadlessTransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" aria-hidden="true" />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-2.5 text-center laptop:p-4">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel
              class="flex w-full max-w-[1101px] transform flex-col overflow-hidden rounded-lg bg-modal px-2.5 pt-16 pb-[50px] text-left align-middle shadow-xl transition-all tablet:px-6 laptop:px-12 laptop:py-16"
            >
              <button
                class="absolute top-2 right-2 hover:text-[#161616] tablet:top-4 tablet:right-4"
                ref="initialFocusBtn"
                @click="$emit('close')"
              >
                <Icon name="clarity:close-line" size="26" />
              </button>
              <div class="flex flex-col laptop:flex-row laptop:justify-between">
                <div class="flex flex-col items-center laptop:order-2 laptop:flex-row">
                  <NuxtLink
                    :to="props.event?.event.attributes?.organizerWebsite || '#'"
                    :title="props.event?.event.attributes?.organizerName"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hover:text-ng800"
                  >
                    <figure class="flex flex-col items-center justify-center text-center">
                      <img
                        :src="props.event?.event.attributes?.image?.data?.attributes?.url"
                        :alt="props.event?.event.attributes?.image?.data?.attributes?.alternativeText || ''"
                        width="270"
                        draggable="false"
                        height="270"
                        class="h-full max-h-[270px] object-contain laptop:w-[270px] laptop:max-w-[270px]"
                      />
                      <figcaption class="subtitle mt-6 mb-10 flex items-center">
                        {{ $t("visit-organizer") }} <Icon name="bi:arrow-up-right" class="ml-2.5" size="18" />
                      </figcaption>
                    </figure>
                  </NuxtLink>
                </div>
                <div class="laptop:max-w-[711px]">
                  <div class="date laptop:mb-10">{{ props.event?.date }}</div>
                  <h1 class="laptop:mb-10">{{ props.event?.event.attributes?.venue }}</h1>
                  <p class="mb-10">{{ props.event?.event.attributes?.description }}</p>
                </div>
              </div>
              <CustomizeBtn
                :text="$t('event-details')"
                class="cursor-pointer self-center whitespace-nowrap text-[#1F2C12]"
                :link="props.event?.event.attributes?.eventLink || '#'"
                external
              />
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { EventInformationFragment } from "#gql";

const { t: $t } = useI18n();

const props = defineProps<{
  event: { event: EventInformationFragment; date: string } | null | undefined;
  isOpen: boolean;
}>();

const initialFocusBtn = ref(null);
</script>
